export default {
  header: '系統管理',
  auditTrail: {
    title: '動作稽查',
    function: '動作內容',
    user: '用戶',
    actionDetail: '動作詳情',
    actionDate: '最後行動日期',

  },
  bulletin: {
    title: '公告',
    category: '類別',
    category: '類別',
    header: '公告列表',
    bulletinList: '列表',
    create: '創建公告',
    edit: '修改',
    view: '檢視',
    attachment: '附件',
    deleteConfirmTitle:'確認 "刪除" 下列公告？',
    subject: '主題',
    content: '內容',
    createTime:'創建日期',
    updateTime:'修改日期',
    preview:'摘要',
  },

  agent: {
    ID: 'ID',
    agentList: '列表',
    create: '創建財務顧問',
    success: '創建 / 修改成功',
    confirmation: '確認 創建或修改 此財務顧問嗎？',
    header: '財務顧問',
    agentInformation: '財務顧問詳情',
    agentCode: '財務顧問代碼',
    joinDate: '加入日期',
    leaveDate: '離職日期',
    agentTeam: '財務顧問團隊',
    position: '職位',
    name: '財務顧問姓名',
    cibLicense: 'CIB 牌照',
    mpfaLicense: 'MPFA 牌照',

    ociLicensePrinciples: 'OCI 保險原理及實務',
    ociLicenseGeneral: 'OCI 一般保險',
    ociLicenseLongTerm: 'OCI 長期保險',
    ociLicenseLinkedLongTerm: 'OCI 投資相連長期保險',

    sfcLicenseType1: 'SFC 第1類牌照',
    sfcLicenseType2: 'SFC 第2類牌照',
    sfcLicenseType3: 'SFC 第3類牌照',
    sfcLicenseType4: 'SFC 第4類牌照',
    sfcLicenseType5: 'SFC 第5類牌照',
    sfcLicenseType6: 'SFC 第6類牌照',
    sfcLicenseType7: 'SFC 第7類牌照',
    sfcLicenseType8: 'SFC 第8類牌照',
    sfcLicenseType9: 'SFC 第9類牌照',
    sfcLicenseType10: 'SFC 第10類牌照',

    userEmail: '用戶電郵',
    language: '偏好系統語言',
    marketingOptOut: '拒絕銷售名單',
    license: '牌照詳情',
    noAgentTeam: '無財務顧問團隊',
    hasAgentTeam: '有財務顧問團隊',
    search: '檢索財務顧問',
    create: '創建財務顧問',
    contactType: '合約類別',
    idType: 'ID 類別',
    maritalStatus: '婚姻狀況',

    parentAgent: '主要顧問',
    providerSplitRate: '保險公司分成比率',
    fyc: '首年佣金',
    provider: '保險公司',
    commission: '第二年後佣金',
    defaultSplitRate: {
      header: '預設抽成比率',
    },
    editSplitRate: '編輯保險公司指定分成率',
    overrideSplitRate: '改寫所有保險公司分成率',
    noParentAgent: '毋主要興問',
    hasParentAgent: '有主要顧問',

    agentSplitModal: {
      editAgentSplitRate: '編輯保險公司指定分成率',
      editAgentSplitRateBody: '編輯保險公司指定分成率只會影響個名保險公司',
      overrideAgentSplitRate: '改寫所有保險公司分成率',
      overrideAgentSplitRateBody: '改寫分成率會影響所有此顧問相關之分成率'
    }
  },

  document: {
    listTitle: '文件管理',
    download: '下載',
    remove: '移除',
    fields: {
      'ID': '編號',
      'documentName': '文件名稱',
      'linkedEntity': '相關個體',
      'fileSize': '檔案大小',
      'documentType': '文檔類別',
      'publicDocument': '公開文件',
      'documentTag': '文件標籤',
      'remarks': '備註',
      'createTime': '創建時間',
      'createUser': '新增用戶',
      'actions': '行動',
    }
  },

  product: {
    list: {
      title: '產品管理',
      search: '搜尋產品',

    },
    create: {
      successMsg: '成功新增產品',
      title: '新增產品',
    },
  },

  contents: {
    EntityManagement: {
      title: '個體管理',
      search: "搜尋",
      perPage: '每頁',
      total: '總數',
      records: '紀錄',
      createBtn: '新增',

      // Core Session
      Core: {
        header: '主個體',
        name: '主',
        contact: { title: '聯絡', },
        customer: { title: '客戶', },
        address: { title: '地址', },
        agent: { title: '顧問', },
        lead: { title: '聯絡', },
        message: { title: '信息', },
        user: { title: '用戶', },
        team: { title: '團隊' }
      },

      OSMLife: {
        header: 'OSM-人壽個體',
        name: 'OSM 人壽',
        product: { title: '產品', },
        policy: { title: '保單', },
        policyPremium: { title: '保單費用', },
        paymentHistory: { title: '付款紀錄', },
        policyFund: { title: '保單資金', },
        investmentStrategy: { title: '投資策略', },
        transactionHistory: { title: '交易歷史', },
        outstandingRequirement: { title: 'OR' },
        outstandingRequirementComment: { title: 'OR 回應', },
        insuredBenefits: { title: '受保利益', },
        pendingOperation: { title: '待辦操作', },
        commission: { title: '佣金', },
        commissionOverride: { title: '抽成佣金', },
      },

      OSMGI: {
        header: 'OSM-一般保險個體',
        name: 'OSM - 一般保險借貸',
        generalPolicy: { title: '一般保險單' },
        loanContract: { title: '借貸合約' },
      },
      DM: {
        header: '文件管理',
        name: 'DM',
        document: { title: '文件' },
      },
      System: {
        name: '系統管理',
        systemLogs: { title: '系統記錄' },
        entitlement: { title: '權利' },
      },
      productManagement: {
        header: '產品',
      },
    }
  },

  userAuthorization: {
    title: '授權',
    header: '用戶授權',

    change: {
      modal: {
        title: '確認要應用這些變更',
        body: '變更會於確認後立即生效'
      },
      header: '變更用戶授權',
      selectedCandidate: '已選擇用戶',
      role: '角色',
      applyChanges: '使用變更'
    },
    list: {
      userType: '用戶類別',
      referenceCode: '參考編號',
      success: '成功變更用戶授權',
      error: '變更用戶授權發生錯誤',
      edit: '編輯',
      header: '用戶授權列表',
      englishName: 'English Name / 中文名',
      roleName: '角色名稱'
    }
  },
  team: {
    header: '團隊',
    list: '列表',
    teamCode: '團隊編號',
    leader: '領袖',
    leaderCode: '領袖顧問編號',
    numberOfMember: '隊員人數',
    createTeam: '創建團隊',
    editTeam: '編輯團隊',
    parentTeam: '主團隊',
    haveParentTeam: '有主團隊?',
    addAgent: '增加顧問',
    removeAgent: '移除顧問',
    addAgentComfirm: '<h4>確認要 <b>增加</b> 以下顧問到此團隊?</h4> <br/> <p>顧問名稱: {agentName}</p>',
    removeAgentComfirm: '<h4>確認要 <b>刪除</b> 以下顧問?</h4> <br/> <p>顧問名稱: {agentName}</p>',
  }
}


// WEBPACK FOOTER //
// ./src/Adm/langs/zh_hk/index.js